export function applyWorkspaceTheme (theme: Record<string, string>) {
  const root = document.documentElement

  Object.entries(theme).forEach(([key, value]) => {
    if (key === '--p') {
      root.style.setProperty('--color-primary', `${value}`)
    } else {
      root.style.setProperty(key, `from ${value} l c h`)
    }
  })
}
